// extracted by mini-css-extract-plugin
export var brand = "_95-9";
export var compact = "_95-6";
export var extraSmall = "_95-7";
export var icon = "_95-0";
export var large = "_95-4";
export var light = "_95-1";
export var medium = "_95-5";
export var outline = "_95-b";
export var primaryDark = "_95-a";
export var primaryLight = "_95-8";
export var primaryModern = "_95-c";
export var success = "_95-2";
export var successSolid = "_95-3";